export const Handle = ({ handle: { id, value, percent }, getHandleProps }) => {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: -1,
        marginTop: -2,
        zIndex: 2,
        width: 12,
        height: 12,
        cursor: 'pointer',
        borderRadius: '50%',
        boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#34568f',
      }}
      {...getHandleProps(id)}
    />
  )
}

export const Track = ({ source, target, getTrackProps }) => {
  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 1,
        backgroundColor: '#7aa0c4',
        borderRadius: 7,
        cursor: 'pointer',
        width: 12,
        marginLeft: -1,
        top: `${source.percent}%`,
        height: `${target.percent - source.percent}%`,
      }}
      {
        ...getTrackProps() /* this will set up events if you want it to be clickeable (optional) */
      }
    >
      <>
        <div
          style={{
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: 14,
            marginTop: 10,
            color: 'yellow',
            width: '100%',
          }}
        >
          <span
            style={{
              position: 'absolute',
              left: '42%',
              border: '1px solid rgb(72,131,181)',
              width: 32,
              height: 32,
              textAlign: 'center',
              paddingLeft: 2,
              paddingTop: 2,
              borderRadius: '50%',
              backgroundColor: 'rgb(72,131,181)',
            }}
          >
            {'#' + target.id.substring(3, 4)}
          </span>
        </div>
      </>
    </div>
  )
}

export const Tick = ({ tick, count }) => {
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          marginTop: -2,
          marginLeft: 0,
          height: 2,
          width: 0,
          backgroundColor: 'rgb(200,200,200)',
          left: `${tick.percent - 1}%`,
        }}
      />
      <div
        style={{
          position: 'absolute',
          marginTop: -20,
          marginLeft: 0,
          fontSize: 12,
          left: `${tick.percent}%`,
        }}
      >
        {tick.value !== 0 ? tick.value : 1}
      </div>
    </div>
  )
}
